export interface bl_mrp_process_instance_line_RowInterface {
  guid: string;
  hdr_guid: string;
  inv_item_guid: string;
  duration: number;
  qty_base: number;
  start_date: string;
  end_date: string;
  namespace: string;
  applet_guid: string;
  module_guid: string;
  acl_config: any;
  acl_policy: any;
  property_json: any;
  status: string;
  revision: string;
  vrsn: string;
  created_date: string;
  updated_date: string;
  created_by_subject_guid: string;
  updated_by_subject_guid: string;
  branch_guid: string;
  location_guid: string;
  fi_item_guid: string;
  quantity_signum: number;
  estimated_start_date: string;
  item_code: string;
  item_name: string;
  item_desc: string;
  batch_no: any;
  serial_no: any;
  item_txn_type: string;
  uom_json: any;
  qty_by_uom: number;
  item_reference_no: string;
  process_line_status: string;
  bin_no: any;
  job_order_line_guid : string;
  qty_planned: number;
  qty_actual: number;
  planned_bin_no: any;
  default_coiling_item: boolean;
}

export class bl_mrp_process_instance_line_RowClass implements bl_mrp_process_instance_line_RowInterface {
  guid: string;
  hdr_guid: string;
  inv_item_guid: string;
  duration: number;
  qty_base: number;
  start_date: string;
  end_date: string;
  namespace: string;
  applet_guid: string;
  module_guid: string;
  acl_config: any;
  acl_policy: any;
  property_json: any;
  status: string;
  revision: string;
  vrsn: string;
  created_date: string;
  updated_date: string;
  created_by_subject_guid: string;
  updated_by_subject_guid: string;
  branch_guid: string;
  location_guid: string;
  fi_item_guid: string;
  quantity_signum: number;
  estimated_start_date: string;
  item_code: string;
  item_name: string;
  item_desc: string;
  batch_no: any;
  serial_no: any;
  item_txn_type: string;
  uom_json: any;
  qty_by_uom: number;
  item_reference_no: string;
  process_line_status: string;
  bin_no: any;
  job_order_line_guid : string;
  qty_planned: number;
  qty_actual: number;
  planned_bin_no: any;
  default_coiling_item: boolean;
}
